import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/auctions";
import type { ResponseConfig } from "@/api/client/auctions";
import type { CancelAuctionMutationResponse, CancelAuctionQueryParams, CancelAuction400, CancelAuction403 } from "../types/CancelAuction";

/**
 * @description Метод предназначен для отмены запроса предложений после его завершения https://confluence.poleinvest.ru/pages/viewpage.action?pageId=463899822

 * @link /v1/auction/do_cancel
 */

export function useCancelAuction <TData = CancelAuctionMutationResponse, TError = CancelAuction400 | CancelAuction403>(params: CancelAuctionQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, void>,
          client?: Partial<Parameters<typeof client<TData, TError, void>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, void> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, void>({
    mutationFn: () => {
      
      return client<TData, TError, void>({
        method: "post",
        url: `/v1/auction/do_cancel`,
        
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
